module.exports = __webpack_public_path__ + "media/application/images/2024/shapes/22-7162b82ec6db927170479f8c90ce1915.png";